import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const EquipmentDetailsAIHistorySkeleton = () =>
  [...Array(3)].map((_) => (
    <tr key={uuidv4()}>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
    </tr>
  ));

export default EquipmentDetailsAIHistorySkeleton;
